var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.001 20c1.306 0 2.373-.923 2.373-2.051H6.628c0 .544.25 1.066.695 1.45.446.385 1.05.601 1.678.601Zm7.12-6.154V8.718c0-3.149-1.946-5.785-5.34-6.482v-.698C10.781.688 9.986 0 9.001 0c-.984 0-1.78.687-1.78 1.538v.698c-3.405.697-5.339 3.323-5.339 6.482v5.128L.352 15.17c-.748.646-.226 1.754.83 1.754H16.81c1.056 0 1.59-1.108.842-1.754l-1.53-1.323Z",
    fill: "#303030"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNotification);
export default __webpack_public_path__ + "static/media/ic_notification.5fcc7218667a368c5ba33c654a14b737.svg";
export { ForwardRef as ReactComponent };